<app-custom-grid
  [columns]="columns"
  [items]="items"
  [templateHeader]="templateHeader"
></app-custom-grid>
<ng-container
  [ngTemplateOutlet]="templateDetail"
  [ngTemplateOutletContext]="{$implicit: { text: '$lbl.dumpsterDistance', value: distance }}"
></ng-container>
<ng-container
  [ngTemplateOutlet]="templateDetail"
  [ngTemplateOutletContext]="{$implicit: { text: '$lbl.lastForceGps', value: gpsLastSent }}"
></ng-container>
<div class="map-wrapper">
  <app-dumpster-map
    *ngIf="dumpsters?.length"
    [items]="dumpsters"
    [markerCustom]="getPinByDumpster"
  ></app-dumpster-map>
</div>
<app-modal-footer
  [onSave]="setSave"
  [onCancel]="setCancel"
  [config]="{
    label: { save: '$lbl.ForceGpsCommand' }
  }"
></app-modal-footer>

<ng-template #templateDetail let-dataItem>
  <div class="detail-wrapper">
    <span class="detail-text">{{ dataItem?.text | translate }}:</span>
    <span>{{ !dataItem?.value ? '-' : dataItem?.value }}</span>
  </div>
</ng-template>

<ng-template #templateHeader let-column>
  <div class="header-wrapper">
    <img alt="dumpster" [src]="getPinByColumn(column)" height="10"/>
    <span>{{ column?.title | translate }}</span>
  </div>
</ng-template>

<ng-template #templateGps let-dataItem>
  <ng-container
    [ngTemplateOutlet]="templateRow"
    [ngTemplateOutletContext]="{$implicit: { text: dataItem?.text, value: dataItem?.value }}"
  ></ng-container>
</ng-template>

<ng-template #templateSitGis let-dataItem>
  <ng-container
    [ngTemplateOutlet]="templateRow"
    [ngTemplateOutletContext]="{$implicit: { text: dataItem?.text, value: dataItem?.valueSitGis }}"
  ></ng-container>
</ng-template>

<ng-template #templateRow let-dataItem>
  <div class="detail-row-wrapper">
    <span class="detail-text">{{ dataItem?.text | translate }}</span>
    <span>{{dataItem?.value ? dataItem?.value : '-'}}</span>
  </div>
</ng-template>